import React, { PropTypes } from 'react';
import VideoOnDemandEditForm from '../../VideoOnDemandEditForm';
import LoadingSpinner from '../../../../LoadingSpinner';

class PromotionNew extends React.Component {
  static propTypes = {
    fetch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
  };

  componentDidMount() {
    this.props.fetch();
  }

  render() {
    let { loading, rest } = this.props;

    return (
      <LoadingSpinner show={loading}>
        <VideoOnDemandEditForm label="Create Video on Demand" {...rest}/>
      </LoadingSpinner>
    );
  }
}

export default PromotionNew;



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/Video/VideoOnDemandNew/VideoOnDemandNew.jsx